// @module BTM.BRHiddenComponent.BRHiddenComponent
define('BTM.BRHiddenComponent.BRHiddenComponent.View'
,	[
		'btm_brhiddencomponent_brhiddencomponent.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		btm_brhiddencomponent_brhiddencomponent_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class BTM.BRHiddenComponent.BRHiddenComponent.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_brhiddencomponent_brhiddencomponent_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/BRHiddenComponent.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return BTM.BRHiddenComponent.BRHiddenComponent.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.BRHiddenComponent.BRHiddenComponent.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
